import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const DisconnectedCloudGlyph = /*#__PURE__*/createElement("g", {
  id: "disconnected_cloud"
}, /*#__PURE__*/createElement("path", {
  d: "M65.1,41.2c-0.4-4.8-4.5-8.6-9.4-8.6c-0.8,0-1.5,0.1-2.3,0.3C50.6,26.4,44.2,22,36.9,22c-9.7,0-17.6,7.6-18,17.2 c-5.8,0.5-10.3,5.4-10.3,11.4c0,5.8,4.3,10.7,10,11.4c0.1,0,0.2,0,0.4,0h8.4c0,0,0.1,0,0.1,0s0.1,0,0.1,0H65 c5.7,0,10.4-4.7,10.4-10.4C75.4,45.9,70.8,41.2,65.1,41.2z M11.6,50.6c0-4.6,3.8-8.4,8.4-8.4c0.7,0,1.4,0.1,2.1,0.3 c-0.1-0.8-0.2-1.6-0.2-2.4c0-8.3,6.7-15,15-15c6.5,0,12,4.1,14.1,9.9L26.9,59H19C14.8,58.5,11.6,54.9,11.6,50.6z M65,59H31.1 l22.9-22.9c0.1-0.1,0.1-0.2,0.2-0.3c0.5-0.1,1-0.2,1.5-0.2c3.6,0,6.4,2.9,6.4,6.4c0,1.1-0.3,2.2-0.8,3.1c1.1-0.6,2.3-1,3.6-1 c4.1,0,7.4,3.3,7.4,7.4C72.4,55.7,69.1,59,65,59z"
}));
const DisconnectedCloud = createSvg({
  name: 'disconnected_cloud',
  path: DisconnectedCloudGlyph
});

export default DisconnectedCloud;
export { DisconnectedCloudGlyph };
